import { useEffect, useState } from 'react'
import { router } from '@inertiajs/react'
import AppLayout from '@/components/AppLayout'
import PageTitle from '@/components/PageTitle'
import { Card } from '@/components/ui/Card'
import { UNASSIGNED, type TreeProps } from './components/api'
import GroupProducts from './components/GroupProducts'
import GroupToolbar from './components/GroupToolbar'
import GroupTree from './components/GroupTree'

export default function ProductNodesIndex(props: TreeProps) {
  const [tree, setTree] = useState<TreeProps>({ groups: props.groups, unassigned_count: props.unassigned_count })
  const [selectedId, setSelectedId] = useState(UNASSIGNED)
  const [adding, setAdding] = useState<{ parentId: string | null } | null>(null)
  // Deleting a group reloads the page data, so counts above it stay right.
  useEffect(() => setTree({ groups: props.groups, unassigned_count: props.unassigned_count }), [props.groups, props.unassigned_count])
  const selected = tree.groups.find((g) => g.id === selectedId)

  return (
    <AppLayout header={<PageTitle title="Product groups" subtitle="Group products the way your team plans them" />}>
      <Card className="grid grid-cols-1 overflow-clip md:grid-cols-[minmax(260px,1fr)_2fr]">
        <div className="border-b border-border md:border-b-0 md:border-r">
          <GroupTree
            groups={tree.groups}
            unassignedCount={tree.unassigned_count}
            selectedId={selectedId}
            adding={adding}
            onSelect={setSelectedId}
            onAdd={(parentId) => setAdding({ parentId })}
            onCancelAdd={() => setAdding(null)}
            onCreated={(t) => { setTree(t); setAdding(null) }}
          />
        </div>
        <div>
          {selected && (
            <GroupToolbar
              group={selected}
              onTree={setTree}
              onAddSub={() => setAdding({ parentId: selected.id })}
              onDeleted={() => {
                setSelectedId(UNASSIGNED)
                router.reload({ only: ['groups', 'unassigned_count'] })
              }}
            />
          )}
          <GroupProducts groups={tree.groups} selectedId={selectedId} onTree={setTree} />
        </div>
      </Card>
    </AppLayout>
  )
}
